import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { Allow } from '../../auth/accessToken';
import { AuthenticatedUser } from '../../auth/types';
import Page from '../../components/Page';
import { colors, distances, globalMobileBreakpoint, globalPageMaxWidth } from '../../styles/constants';

import { useAccountId } from '../../auth/useAccountId';
import Insight from './Insight';
import NavBar from './NavBar';


type DashboardProps = {
    user: AuthenticatedUser;
}

const Dashboard = ({ user }: DashboardProps) => {
    const { t } = useTranslation();
    const accountId = useAccountId();
    const account = user.account_user.accounts.find((account) => account.account_id === accountId);
    const name = account && account.business_name;
    const orgNumber = account && account.organization_number;
    const preTitle = [name, orgNumber].filter((x) => x).join(' ');

    return (
        <Page title={preTitle ? `${preTitle}` : t('dashboard.title')} hasEnvFrame={true}>
            <ContentWrapper>
                <NavBar accountId={accountId}></NavBar>
                <Allow anyOfScopes={[['admin'], ['admin:accounts'], ['admin:insight'], ['read:insight']]}>
                    <Insight />
                </Allow>
            </ContentWrapper>
        </Page>
    );
};

const ContentWrapper = styled.section`
    color: ${colors.text};
    padding: 0;
    width: 100%;
    margin: 0 auto;
    border-radius: 2px;
    position: relative;

    @media (max-width: ${globalMobileBreakpoint}px) {
        padding: 0 ${distances.small};
        max-width: 100%;
    }
`;

export default memo(Dashboard);
